import styled from "styled-components";
import { Nav, NavItem } from "react-bootstrap";

export const NavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
    }

    @media (max-width: 1823px) {
        & > li > a {
            font-size: 13px;
        }

        & > li.active > a {
            font-size: 14px;
            line-height: 20px;
        }
    }
`;

interface INavItemProps {
    tabWidth?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }
`;

export const GridWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '80vh'};

    .action-menu {
        overflow: visible;
        // border-bottom: none;
        line-height: 25px;
        // border-color: #ccc;
        display: flex;
        align-items: center;
        // padding-left: 0px;
        // padding-right: 0px;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu > .ag-react-container > div > .btn-group {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        // border-top: 1px solid #ccc !important;
        // border-right: 1px solid white !important;
        // border-bottom: 1px solid white !important;
        // border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.headerBgColor ? p.headerBgColor : '#123'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
    }

    .ag-cell {
        // border-right-color: black !important;
        // border-right-width: 1px !important;
        // border-right-style: solid !important;
    }

    .ag-header-cell,  .ag-header-group-cell {
        // border-right: 1px solid black !important;
    }

    // .ag-header-cell::after {
    //     border-right: 1px solid #ccc;
    //     content: " ";
    //     height: 16px;
    //     margin-top: 4px;
    //     position: absolute;
    //     text-indent: -2000px;
    //     top: 0;
    //     right: 0;
    // }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-hover {
        // background-color: #ddd;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
    }

    .center-list-cell-highlight {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        background-color: yellow;
    }

    .center-list-header {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // padding-bottom: 4px;
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }
`;